var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 0H2.22222C0.996528 0 0 1.28125 0 2.85764V17.1424C0 18.7188 0.996528 20 2.22222 20H17.7778C19.0035 20 20 18.7188 20 17.1424V2.85764C20 1.28125 19.0035 0 17.7778 0ZM15.2222 13.8715C15.2222 14.6181 14.6181 15.2257 13.8681 15.2257H6.12847C5.38194 15.2257 4.77431 14.6215 4.77431 13.8715V6.12847C4.77431 5.38194 5.37847 4.77431 6.12847 4.77431H13.8681C14.6146 4.77431 15.2222 5.37847 15.2222 6.12847V13.8715Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.518d4a8e56e32e0b212335854b69faf7.svg";
export { ForwardRef as ReactComponent };